import { useState, useEffect } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "../ui/dialog";
import { InquiryForm } from "./InquiryForm";

export const InquiryModal = () => {
  const [open, setOpen] = useState(false);
  const [source, setSource] = useState("Website Inquiry");

  useEffect(() => {
    const handler = (e) => { setSource(e.detail?.source || "Website Inquiry"); setOpen(true); };
    window.addEventListener("open-inquiry", handler);
    return () => window.removeEventListener("open-inquiry", handler);
  }, []);

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogContent className="max-w-lg w-[95vw] max-h-[90vh] overflow-y-auto bg-white" data-testid="inquiry-modal">
        <DialogHeader>
          <DialogTitle className="font-display text-2xl text-oyf-black">Send an Inquiry</DialogTitle>
        </DialogHeader>
        <InquiryForm source={source} />
      </DialogContent>
    </Dialog>
  );
};
